import { dateToYYYYMMDD } from "./dates";

export type ReviewHistory = Map<string, number>;

export function reviewStreak(
  hist?: ReviewHistory | undefined | null,
  studyGoal = 0,
  today: Date = new Date(),
): number {
  if (!hist) {
    return Number.NaN;
  }
  if (hist.size === 0) {
    return 0;
  }

  // Subtract days from a date string
  const subtractDays = (date: Date, days: number): Date => {
    const copy = new Date(date);
    copy.setDate(date.getDate() - days);
    return copy;
  };

  const effectiveStudyGoal = studyGoal > 0 ? studyGoal : 1;

  const todayYMD = dateToYYYYMMDD(today);
  const yesterday = subtractDays(today, 1);
  const yesterdayYMD = dateToYYYYMMDD(yesterday);

  if (
    (hist.get(todayYMD) ?? 0) < effectiveStudyGoal &&
    (hist.get(yesterdayYMD) ?? 0) < effectiveStudyGoal
  ) {
    return 0;
  }

  const todayCount = hist.get(todayYMD) ?? 0;
  let streak = todayCount >= effectiveStudyGoal ? 1 : 0;

  let dateToCheck = yesterday;
  let dateToCheckYMD = dateToYYYYMMDD(dateToCheck);
  let dateToCheckCount = hist.get(dateToCheckYMD) ?? 0;
  while (hist.has(dateToCheckYMD) && dateToCheckCount >= effectiveStudyGoal) {
    streak += 1;
    dateToCheck = subtractDays(dateToCheck, 1);
    dateToCheckYMD = dateToYYYYMMDD(dateToCheck);
    dateToCheckCount = hist.get(dateToCheckYMD) ?? 0;
  }

  return streak;
}
